module.exports = __webpack_public_path__ + "static/img/two_879zhongguokexuejishu.95b5498.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/two_879zhongguokexuejishu.jpg
// module id = q77M
// module chunks = 36